import React from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormTextField from "components/form/form-textfield";
import { CardWithDelete } from "components/card";

const ContactForm = ({ index, collectionName, element, onChange, onDelete, intl }) =>
  element ? (
    <CardWithDelete onDelete={onDelete}>
      <DataGridItem>
        <FormTextField
          type="text"
          id={`${collectionName}.${index}.name`}
          name={`${collectionName}.${index}.name`}
          value={element.name}
          onChange={onChange}
          label={intl.formatMessage({ id: "common.name" })}
        />
      </DataGridItem>
      <DataGridItem>
        <FormTextField
          type="text"
          id={`${collectionName}.${index}.description`}
          name={`${collectionName}.${index}.description`}
          value={element.description}
          onChange={onChange}
          label={intl.formatMessage({ id: "common.description" })}
        />
      </DataGridItem>
      <DataGridItem>
        <FormTextField
          type="text"
          id={`${collectionName}.${index}.email`}
          name={`${collectionName}.${index}.email`}
          value={element.email}
          onChange={onChange}
          label={intl.formatMessage({ id: "common.contact.email" })}
        />
      </DataGridItem>
      <DataGridItem>
        <FormTextField
          type="text"
          id={`${collectionName}.${index}.telephone`}
          name={`${collectionName}.${index}.telephone`}
          value={element.telephone}
          onChange={onChange}
          label={intl.formatMessage({ id: "common.contact.telephone" })}
        />
      </DataGridItem>
    </CardWithDelete>
  ) : null;

ContactForm.propTypes = {
  /**
   * Índice del elemento en la colección
   */
  index: PropTypes.number,
  /**
   * Nombre de la colección
   */
  collectionName: PropTypes.string,
  /**
   * Función que se invoca al modificar algún valor
   */
  onChange: PropTypes.func,
  /**
   * Función que se invoca al eliminar el layout
   */
  onDelete: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  element: PropTypes.object,
};

export default injectIntl(ContactForm);
